import styled, { css } from "styled-components";
import { theme } from "uikit";

/**
 * Lightweight table for technical data.
 *
 * The uikit table targets domain entities with sorting and selection, while
 * this section only needs a dense readable grid of numbers.
 */
const DataTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	table-layout: auto;

	font-family: Lato;
	font-size: 13px;

	th,
	td {
		padding: 6px 10px;
		text-align: left;
		border-bottom: 1px solid ${theme.colors.color_border_basic};
		white-space: nowrap;
	}

	th {
		position: sticky;
		top: 0;
		z-index: 1;

		background: ${theme.colors.white};
		font-weight: 600;
		color: ${theme.colors.secondary};
	}

	td {
		color: ${theme.colors.primary};
	}

	td.numeric,
	th.numeric {
		text-align: right;
		font-variant-numeric: tabular-nums;
	}

	td.wide {
		white-space: normal;
		word-break: break-word;
	}
`;

export const TableScroll = styled.div`
	width: 100%;
	max-width: 100%;
	min-width: 0;
	overflow-x: auto;
	overflow-y: visible;
`;

export const ClickableRow = styled.tr<{ active?: boolean }>`
	cursor: pointer;

	${({ active }) =>
		active
			? css`
					background: ${theme.colors.button_secondary};
			  `
			: ""}

	&:hover {
		background: ${theme.colors.button_secondary};
	}
`;

export const Accent = styled.span<{ tone?: "danger" | "warning" | "muted" }>`
	color: ${({ tone }) => {
		if (tone === "danger") return theme.colors.negative;
		if (tone === "warning") return theme.colors.warning;
		if (tone === "muted") return theme.colors.secondary;
		return theme.colors.primary;
	}};
`;

export default DataTable;
